import React from 'react';
import PropTypes from 'prop-types';
import {
  Template,
  TemplatePlaceholder,
  Plugin,
  TemplateConnector
} from '@devexpress/dx-react-core';

export const AddComponentsPlugin = props => {
  AddComponentsPlugin.propTypes = {
    before: PropTypes.object,
    after: PropTypes.func,
    templateName: PropTypes.oneOf(['toolbarContent', 'footer'])
  };

  const { templateName, before, after } = props;

  return (
    <Plugin name="AddComponentsPlugin">
      <Template name={templateName}>
        <TemplateConnector>
          {() => <React.Fragment>{before}</React.Fragment>}
        </TemplateConnector>
        <TemplatePlaceholder />
        {after && (
          <TemplateConnector>
            {() => <React.Fragment>{after()}</React.Fragment>}
          </TemplateConnector>
        )}
      </Template>
    </Plugin>
  );
};

export default AddComponentsPlugin;
